import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import OrgProfileAssistant from "@/components/OrgProfileAssistant";
import { Buildings, ArrowRight } from "@phosphor-icons/react";

export default function Onboarding() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-zinc-50 gf-grid-bg flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-2xl" data-testid="onboarding-page">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-10 w-10 bg-blue-700 flex items-center justify-center">
            <Buildings size={18} className="text-white" weight="bold" />
          </div>
          <div>
            <div className="font-display font-black text-lg tracking-tight">GRANTFLOW</div>
            <div className="text-[9px] font-mono uppercase tracking-widest text-zinc-500">Federal grants suite</div>
          </div>
        </div>

        <div className="gf-overline">Step 1 of 1 · Optional</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight mt-2">
          Tell us about your organization.
        </h1>
        <p className="text-zinc-600 mt-3 text-sm leading-relaxed max-w-xl">
          We&apos;ll analyze your website (or a few keywords) and suggest the exact search terms to
          find your grants — you can also turn them into daily email alerts.
        </p>

        <div className="mt-6">
          <OrgProfileAssistant onKeywordSelect={(kw) => navigate(`/search?q=${encodeURIComponent(kw)}`)} />
        </div>

        <div className="mt-6 flex items-center gap-4">
          <Button
            onClick={() => navigate("/dashboard")}
            data-testid="onboarding-continue-btn"
            className="gf-sharp bg-blue-700 hover:bg-blue-800 text-white font-bold uppercase tracking-widest px-8"
          >
            Continue to dashboard <ArrowRight size={14} className="ml-2" />
          </Button>
          <button
            type="button"
            onClick={() => navigate("/dashboard")}
            data-testid="onboarding-skip-btn"
            className="text-xs font-mono uppercase tracking-widest text-zinc-500 hover:text-zinc-900"
          >
            Skip for now
          </button>
        </div>
      </div>
    </div>
  );
}
